import  {eXcell,__extends} from './eXcell';

var eXcell_ro = (function (_super) {
    __extends(eXcell_ro, _super);
    function eXcell_ro(a) {
        _super.call(this);
        if (a) {
            this.cell = a;
            this.grid = this.cell.parentNode.grid;
        }
    }
    eXcell_ro.prototype.edit = function () { };
    eXcell_ro.prototype.isDisabled = function () {
        return true;
    };
    eXcell_ro.prototype.getValue = function () {
        return this.cell._clearCell
            ? ""
            : this.cell.innerText.toString()._dhx_trim();
    };
    eXcell_ro.prototype.getHtmlValue = function () {
        return this.cell._clearCell
            ? ""
            : this.cell.innerText.toString()._dhx_trim();
    };
    return eXcell_ro;
})(eXcell);
window.eXcell_ro = eXcell_ro;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/gridXCell/eXcell_ro.js